import { toast } from "react-toastify";
import { store } from "store";
import defaultErrorHandler from "api/global/default-error-handler";


import {
    requestPlanogramList,
    requestPlanogramCopyById,
    requestPlanogramGetById,
    requestPlanogramDeleteById,
    requestPlanogramCreate,
    requestPlanogramUpdate,
    requestPlanogramGetLayoutById,
    requestPlanogramCreateLayoutById,
    requestPlanogramGetDataListById,
    requestPlanogramCreateData,
    requestPlanogramGetDataByDataId,
    requestPlanogramUpdateDataByDataId,
    requestPlanogramDeleteDataByDataId,
    requestGetCategories,
    requestGetEntryTypes, requestPlanogramDataImport
} from "api/menu/master-files/planogram-maintenance/requests";

export const PLANOGRAM_LOADING = "PLANOGRAM_LOADING";
export const PLANOGRAM_ERROR = "PLANOGRAM_ERROR";

export const PLANOGRAM_GET_LIST = "PLANOGRAM_GET_LIST";
export const PLANOGRAM_GET_BY_ID = "PLANOGRAM_GET_BY_ID";
export const PLANOGRAM_COPY_BY_ID = "PLANOGRAM_COPY_BY_ID";
export const PLANOGRAM_UPDATE = "PLANOGRAM_UPDATE";
export const PLANOGRAM_DELETE = "PLANOGRAM_DELETE";

export const PLANOGRAM_LAYOUT_LIST = "PLANOGRAM_LAYOUT_LIST";

export const PLANOGRAM_DATA_GET_LIST = "PLANOGRAM_DATA_GET_LIST";
export const PLANOGRAM_DATA_CREATE_LIST = "PLANOGRAM_DATA_CREATE_LIST";
export const PLANOGRAM_DATA_GET_BY_ID = "PLANOGRAM_DATA_GET_BY_ID";
export const PLANOGRAM_DATA_CREATE_DATA = "PLANOGRAM_DATA_CREATE_DATA";
export const PLANOGRAM_DATA_DELETE = "PLANOGRAM_DATA_DELETE";

export const PLANOGRAM_GET_CATEGORIES = "PLANOGRAM_GET_CATEGORIES";
export const PLANOGRAM_GET_ENTRY_TYPES = "PLANOGRAM_GET_ENTRY_TYPES";

export const setLoading = (status) => ({
    type: PLANOGRAM_LOADING,
    payload: status
});

export const getPlanogramList = () => dispatch => {
    dispatch(setLoading(true));
    requestPlanogramList()
        .then(response => {
            dispatch({
                type: PLANOGRAM_GET_LIST,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const planogramCopyById = (planogramId) => dispatch => {
    dispatch(setLoading(true));
    requestPlanogramCopyById(planogramId)
        .then(response => {
            toast("Planogram successfully copied", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch({
                type: PLANOGRAM_COPY_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const getPlanogramById = (planogramId) => dispatch => {
    dispatch(setLoading(true));
    requestPlanogramGetById(planogramId)
        .then(response => {
            dispatch({
                type: PLANOGRAM_GET_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const deletePlanogramById = (planogramId) => dispatch => {
    dispatch(setLoading(true));
    requestPlanogramDeleteById(planogramId)
        .then(() => {
            toast("Planogram successfully deleted", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch({
                type: PLANOGRAM_DELETE,
                payload: planogramId
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const createPlanogram = (data, callback = false) => dispatch => {
    dispatch(setLoading(true));
    requestPlanogramCreate(data)
        .then(response => {
            dispatch({
                type: PLANOGRAM_UPDATE,
                payload: response.data
            });
            toast("Planogram successfully created", {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const updatePlanogram = (planogramId, data, callback = false) => dispatch => {
    dispatch(setLoading(true));
    requestPlanogramUpdate(planogramId, data)
        .then(response => {
            dispatch({
                type: PLANOGRAM_UPDATE,
                payload: response.data
            });
            toast("Planogram successfully updated", {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const getPlanogramLayoutList = (planogramId, pageNumber = 1) => dispatch => {
    dispatch(setLoading(true));
    const state = store.getState();
    const pageSize = state.planogramMaintenance.planogramSingle.numberOfRows;
    requestPlanogramGetLayoutById(planogramId, pageNumber, pageSize || 100)
        .then(response => {
            dispatch({
                type: PLANOGRAM_LAYOUT_LIST,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const createPlanogramLayout = (planogramId, data) => dispatch => {
    dispatch(setLoading(true));
    requestPlanogramCreateLayoutById(planogramId, data)
        .then(response => {
            dispatch({
                type: PLANOGRAM_LAYOUT_LIST,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const getPlanogramDataList = (planogramId) => dispatch => {
    dispatch(setLoading(true));
    requestPlanogramGetDataListById(planogramId)
        .then(response => {
            dispatch({
                type: PLANOGRAM_DATA_GET_LIST,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const importPlanogramData = (planogramId, autoPopulate, data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestPlanogramDataImport(planogramId, autoPopulate, data)
        .then(() => {
            toast("Planogram data successfully uploaded", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch(setLoading(false));
            if (callback) {
                callback();
            }
            dispatch(getPlanogramDataList(parseInt(planogramId, 0)));
        })
        .catch(error => {
            if (callback) {
                callback();
            }
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const getPlanogramDataById = (planogramId, dataId) => dispatch => {
    dispatch(setLoading(true));
    requestPlanogramGetDataByDataId(planogramId, dataId)
        .then(response => {
            dispatch({
                type: PLANOGRAM_DATA_GET_BY_ID,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const createPlanogramData = (planogramId, data, callback = false) => dispatch => {
    dispatch(setLoading(true));
    requestPlanogramCreateData(planogramId, data)
        .then(response => {
            dispatch({
                type: PLANOGRAM_DATA_CREATE_LIST,
                payload: response.data
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const updatePlanogramDataByDataId = (
    planogramId,
    planogramDataId,
    data,
    callback = false
) => dispatch => {
    dispatch(setLoading(true));
    requestPlanogramUpdateDataByDataId(planogramId, planogramDataId, data)
        .then(response => {
            dispatch({
                type: PLANOGRAM_DATA_CREATE_DATA,
                payload: response.data
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const deletePlanogramDataByDataId = (planogramId, planogramDataId) => dispatch => {
    dispatch(setLoading(true));
    requestPlanogramDeleteDataByDataId(planogramId, planogramDataId)
        .then(() => {
            dispatch({
                type: PLANOGRAM_DATA_DELETE,
                payload: {
                    planogramId,
                    planogramDataId
                }
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const getCategories = () => dispatch => {
    dispatch(setLoading(true));
    requestGetCategories()
        .then(response => {
            dispatch({
                type: PLANOGRAM_GET_CATEGORIES,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};

export const getEntryTypes = () => dispatch => {
    dispatch(setLoading(true));
    requestGetEntryTypes()
        .then(response => {
            dispatch({
                type: PLANOGRAM_GET_ENTRY_TYPES,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PLANOGRAM_ERROR));
        });
};
